import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api from '../../services/api';


export const useSubIndustryStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      // If it's FormData, let axios/browser handle the Content-Type and boundary
      const config = body instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      const res = await api.post("/subindustry/create", body, config);
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['viewSubIndustry'] });
      queryClient.invalidateQueries({ queryKey: ['allSubIndustries'] });
      queryClient.invalidateQueries({ queryKey: ['subIndustriesList'] });
    },
  });

};